import * as Yup from 'yup';

export const withdrawalValidationShema = Yup.object().shape({
    withdrawalValue: Yup.string()
        .min(1, 'O valor digitado tem que ser maior que zero')
        .required('Este campo é obrigatório'),
});
